<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <!--<button class="btnback btn btn-outline-success"><i class="fa fa-chevron-left"></i></button>-->
        <button class="btn btn-outline-success" type="button" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo Grupo</button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">


    <div class="row">
        <div class="col-md-12">
            <h4>Buscador de Grupos</h4>
        </div>
    </div>


    <div class="row">
        <div class="col-md-12">
            <div class="card card-accent-success animated fadeIn">
                <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                   [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                    <div class="card-header-buscador">
                        <i class="fa fa-filter"></i> Filtros
                        <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>

                <div class="card-body">
                    <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                    <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpDescripcion">Embalaje obligatorio</label>
                                <p-selectButton class="selectButtonCust"
                                                [options]="listSiNoTodos"
                                                formControlName="EmbalajeObligatorio"
                                                unselectable="true">
                                </p-selectButton>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group-0 float-right">

                                <div class="btn-group">
                                    <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                </div>

                                <div class="btn-group">
                                    <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="animated fadeIn">
        <!-- DATAGRID -->
        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Grupos
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultGrupo.ResultList"
                                [columns]="cols" sortField="Descripcion" [loading]="loading" [paginator]="false"
                                [lazy]="false" styleClass="table table-responsive-sm table-striped table-sm"
                                [ngClass]="displayGridHidden(resultGrupo.ResultList)">

                            <!-- Cabecera de la tabla -->
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        {{col.header}}
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr [pSelectableRow]="rowData" title="Ver Detalle">

                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <!-- Campos normales -->
                                        <span *ngIf="col.field !== 'Link' && col.field !== 'EmbalajeObligatorio'">
                                            {{ rowData[col.field] }}
                                        </span>

                                        <!-- Campo booleano con pipe -->
                                        <span *ngIf="col.field === 'EmbalajeObligatorio'">
                                            {{ rowData[col.field] | siNo }}
                                        </span>

                                        <!-- Botones -->
                                        <div *ngIf="col.field === 'Link'" class="btn-group">
                                            <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                    class="btn btn-sm btn-warning">
                                                <span class="fa fa-edit"></span>
                                            </button>
                                            <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                    class="btn btn-sm btn-danger">
                                                <span class="fa fa-remove"></span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
